import React, { Component } from 'react';
import {Badge, Button, Overlay, OverlayTrigger, Tooltip} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheckCircle, faQuestionCircle, faTimesCircle, faUserCheck, faUserTie, faUserXmark, faWarning} from '@fortawesome/free-solid-svg-icons';
import DateTimeUtil from '../../util/DateTimeUtil';

class UserConsentBadge extends Component {
    constructor(props) {
        super(props);
        this.userConsent = props.userConsent;
        this.state = {
            showCount: false,
            target: null,
        };
    }

    handleButtonClick = (event) => {
        this.setState((prevState) => ({
            showCount: true,
            target: event.target,
        }));
        // Set a timeout to hide the tooltip after 3 seconds
        setTimeout(() => {
            this.setState({ showCount: false });
        }, 3000);
    };


    answerGiven(){
        return this.userConsent.consentEvents.length > 0;
      }


      getLatest(){
        if(this.userConsent.consentEvents.length > 0){
            const consentEvents = this.userConsent.consentEvents;
            const latestConsentEvent = consentEvents.reduce((latest, current) => {
              return new Date(current.date) > new Date(latest.date) ? current : latest;
            }, consentEvents[0]);
            return latestConsentEvent;
        }else{
            return null;
        }

      }

    isAccepted(){
        const consentEvents = this.userConsent.consentEvents;
          const latestConsentEvent = consentEvents.reduce((latest, current) => {
            return new Date(current.date) > new Date(latest.date) ? current : latest;
          }, consentEvents[0]);
          if (latestConsentEvent) {
            return latestConsentEvent.accepted;
          } else {
            return false; // oder ein Fallback-Text, wenn keine Daten vorhanden sind
          }
      }

    render() {


        return (
            <>
                <Button
                    className={"UserConsentBadge"}
                    variant={this.answerGiven()?(this.isAccepted()?"success":"danger"):"warning"}
                    size="sm"
                    style={{ marginRight: '1em', marginBottom: '0.2em' }}
                    onClick={this.handleButtonClick}
                >
                    {this.answerGiven()? (
                        <>
                            {this.isAccepted()?
                            <FontAwesomeIcon icon={faCheckCircle} style={{ padding: '0.2em' }}></FontAwesomeIcon>:
                            <FontAwesomeIcon icon={faTimesCircle} style={{ padding: '0.2em' }}></FontAwesomeIcon>}
                        </>
                    ) : <FontAwesomeIcon icon={faQuestionCircle} style={{ padding: '0.2em' }}></FontAwesomeIcon>}
                </Button>
                <Overlay target={this.state.target} show={this.state.showCount} placement="top">
                    {(props) => (
                        <Tooltip id={"supervisor-overlay"} {...props}>
                            {this.answerGiven()? (
                                <>
                                    {this.isAccepted()?"Einverständnis zu Foto- & Videoaufnahmen: akzeptiert am "+DateTimeUtil.getHumanReadableDateTime(this.getLatest().date)+" Uhr"
                                    :"Einverständnis zu Foto- & Videoaufnahmen: abgelehnt am "+DateTimeUtil.getHumanReadableDateTime(this.getLatest().date)+" Uhr"
                                    }
                                </>
                            ) : 'Einverständnis zu Foto- & Videoaufnahmen: Keine Antwort'}
                        </Tooltip>
                    )}
                </Overlay>
            </>
        );
    }
}

export default UserConsentBadge;